/* eslint-disable react/no-unknown-property */
import {
  Card, HStack, ICON_FOLDER_OUTLINE, Skeleton, TextSkeleton,
} from '@doveit/bricks';
import React from 'react';
import CanvaDesignPreview from '../canva-design-preview/CanvaDesignPreview';
import { CANVA_CARD_ASPECT_RATIO } from '../../constants';
import * as styles from './CanvaCard.style';
import { CanvaCardType, mapTypeToBadgeLabel } from './CanvaCard';

export interface CanvaCardSkeletonProps {
  type: CanvaCardType,
}

const CanvaCardSkeleton: React.FC<CanvaCardSkeletonProps> = ({ type }) => (
  <Card>
    <CanvaDesignPreview
      aspectRatio={CANVA_CARD_ASPECT_RATIO}
      alt="canva-card-skeleton"
      iconPlaceholder={type === 'folder' ? ICON_FOLDER_OUTLINE : undefined}
      badgeLabel={mapTypeToBadgeLabel[type]}
    />
    <Card.Content>
      <div css={styles.info}>
        <p css={styles.titleWrapper}>
          <TextSkeleton width="12rem" count={2} />
        </p>
      </div>
      <HStack justifyContent="space-between" gap={75}>
        <div css={styles.primaryActionWrapper}>
          <Skeleton height="1.5rem" />
        </div>
      </HStack>
    </Card.Content>
  </Card>
);

export default CanvaCardSkeleton;
